import React, { Component } from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faBinoculars, faShareSquare } from "@fortawesome/free-solid-svg-icons";
import "../../assets/css/attrib-cards.css";
import AppConfig from "../AppConfig/AppConfig.js";
import AuthService from "../AuthService/AuthService.js";
import GlasschainHttpClient from "../ApiService/GlasschainHttpClient.js";
import { toCardId } from "./AttribCardUtils.js";
import CreatableSelect from "react-select/creatable";
import { isCompositeComponentWithType } from "react-dom/test-utils";

const components = {
  DropdownIndicator: null,
};

/*
const createOption = (label) => ({
  label,
  value: label,
});
*/

Object.byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

export default class AttribMraLookupMapCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardState: "untouched",
      cardValue: {palletIds: []},
      lookupButtonEnabled: false,
      inLookup: false,
      lookupError: false,
      lookupErrMsg: "",

      bypassButtonVisible: false,
      bypassButtonEnabled: false,
      inBypass: false,
      bypassError: false,
      bypassErrMsg: "",
      bypassResultMsg: "",

      inputValue: "",
      mraAssocPalletIds: [],
      mraPalletPairs: [],
      showPalletsBar: false,
      mraId: "",
      mraInput: ""
    };
    this.appConfig = new AppConfig();
    this.auth = new AuthService();
    this.httpClient = new GlasschainHttpClient();
    this.gcid = this.auth.getGcid();
    this.Id = toCardId(this.props.attribTitle);

    this.renderState = this.renderState.bind(this);
    this.renderUntouchedState = this.renderUntouchedState.bind(this);
    this.renderActiveState = this.renderActiveState.bind(this);
    this.onCardClick = this.onCardClick.bind(this);
    this.onLoseFocus = this.onLoseFocus.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.mapEntityFields = this.mapEntityFields.bind(this);

    this.parseType = this.props.parseType;
    this.fieldMap = this.props.fieldMap;
  }

  componentDidUpdate(prevProps, prevState) {
    let oldVal = prevState.cardValue;
    let newVal = this.props.valueBag[this.Id];
    //console.log("Id: " + this.Id + " Old: " + oldVal + " New: " + newVal);
    if (oldVal !== newVal) {
      this.setState({
        cardValue: newVal,
      });
      if (this.state.cardState !== "active") {
        this.setState({ cardState: newVal ? "touched" : "untouched" });
      }
    }
  }



  mapEntityFields(entity) {
    console.log("returned entity: ");
    console.log(entity);
    console.info(this.props.fieldMap);
    for (var key in this.props.fieldMap) {
      let entityField = this.props.fieldMap[key];
      var val = Object.byString(entity, entityField);
      console.log(
        "attempting to get val for key " +
          key +
          " from entity field " +
          entityField
      );
      if (val) {
        console.log("attempting to update " + key + " with " + val);
        this.props.onValueChange(key, val);
      }
    }
  }

  onValueChange(ev) {
    var newLookupButtonEnabled = ev.target.value !== "";
    this.setState({
      inLookup: false,
      lookupError: false,
      lookupErrMsg: "",
      cardValue: ev.target.value,
      lookupButtonEnabled: newLookupButtonEnabled,
    });
    this.props.onValueChange(this.Id, ev.target.value);
  }

  onLoseFocus() {
    var newCardState = this.state.cardValue ? "touched" : "untouched";
    this.setState({ cardState: newCardState });
  }

  onCardClick(ev) {
    var newState = "untouched";
    if (this.state.cardState === "active") {
      newState = this.state.cardValue ? "touched" : "untouched";
    } else {
      newState = "active";
    }
    this.setState({ cardState: newState });
    this.props.onToggleCard(this);
  }

  onMraIdChange(ev) {
    console.log("mra bar ev: ");
    console.info(ev.target.value);
    this.setState({
      mraInput: ev.target.value,
    });
  }

  async onBypassClick(ev)
  {
    const blockId = this.props.valueBag["blockid"];
    if ( (!this.state.cardValue) || (!this.state.cardValue.receiptId) || (!this.state.cardValue.palletIds) )
    {
      alert("You must find valid MRA tags to bypass.");
      return;
    }
    if (this.state.cardValue.palletIds.length < 1)
    {
      alert("You must select at least 1 pallet to bypass!");
      return;
    }
    this.setState({inBypass: true});
    var bypassInfoResult = await this.httpClient.fetchBypassInfo(this.gcid, this.props.schemaId, blockId);
    if (!bypassInfoResult.bypassRequestAllowed)
    {
      this.setState({inBypass: false});
      alert(bypassInfoResult.messages[0]);
      return;
    }
    var bypassResult = {
      "gcid": this.gcid, 
      "schemaId": this.props.schemaId, 
      "receiptId": this.state.cardValue.receiptId,
      "tagId": this.state.cardValue.tagId,
      "blockId": this.state.cardValue.blockId,
      "lineId": this.state.cardValue.lineId,
      "associatedPallets": this.state.cardValue.palletIds,
      "bypassRequestDateTime": bypassInfoResult.bypassRequestDateTime,
      "bypassedBy": this.auth.getUser(),
      "bypassLocation": this.auth.getLocation(),
      "bypassRequestAllowed": bypassInfoResult.bypassRequestAllowed,
      "bypassScore": bypassInfoResult.bypassScore,
      "bypassGrade": bypassInfoResult.bypassGrade
    };
    var bypassPostResult = await this.httpClient.postBypass(this.gcid, bypassResult);

    this.setState({inBypass: false});
    // TBD if successful, then quit.
    if (bypassPostResult.httpCode !== "200")
    {
      // TBD - there was some kind of error
      alert("There was some kind of error on posting the bypass information");
      return;
    }
    this.props.onRequestAutoCancel(" Bypassed.");
  }


  async onMraLookupClick(ev) {
    var newMraInfo = {};
    var mraInput = this.state.mraInput;
    console.log("Do Lookup on " + this.state.mraInput);
    this.setState({ inLookup: true });
    var assocMraIds = await this.httpClient.fetchAssociatedMraPalletIds(
      mraInput
    );
    if (assocMraIds.length < 1) {
      this.setState({
        lookupErrMsg: "Unable to locate MRA Tag " + mraInput,
        lookupError: true,
        inLookup: false,
        lookupButtonEnabled: true,
      });
      return;
    }
    console.log("assocMraIds: ");
    console.info(assocMraIds);
    var assocMraIdPairs = assocMraIds.data.map((id) => {
      return { label: id, value: id };
    });

    this.setState({
      mraAssocPalletIds: assocMraIds,
      mraPalletPairs: assocMraIdPairs,
      showPalletsBar: true,

    });

    var mraReceiptResult = await this.httpClient.fetchMraReceipt(mraInput);
    var mraReceipt = mraReceiptResult.data;
    console.log("full receipt:");
    console.info(mraReceipt);
    var palletLine = this.fetchReceiptLineByPalletId(mraReceipt, mraInput);
    //palletLine.growerId = mraReceipt.growerId;
    palletLine.harvestDate = mraReceipt.receiveDateTime;
    palletLine.lot = mraReceipt.lot;
    console.log("palletLine: ");
    console.info(palletLine);
    newMraInfo.receiptId = mraReceipt.transactionId;
    newMraInfo.tagId = mraReceipt.tagId;
    newMraInfo.blockId = palletLine.blockId;
    newMraInfo.lineId = palletLine.lineId;
    newMraInfo.palletIds = assocMraIds.data;

    this.mapEntityFields(palletLine);

    this.setState({cardValue: newMraInfo});
    this.props.onValueChange(this.Id, newMraInfo);


    this.setState({ inLookup: false });
  }

  handleChange = (value, actionMeta) => {
    console.group("Value Changed");
    console.log(value);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    var assocMraIds = value.map((v) => {
      return v.value;
    });
    console.log("assocMraIds: ");
    console.info(assocMraIds);
    this.setState({
      mraAssocPalletIds: assocMraIds,
      mraPalletPairs: value,
    });
    var newMraInfo = this.state.cardValue;
    newMraInfo.palletIds = assocMraIds;
    this.setState({cardValue: newMraInfo});
    this.props.onValueChange(this.Id, newMraInfo);
  };

  fetchReceiptLineByPalletId(mraReceipt, sourcePallet){
    for (var lineI=0; lineI<mraReceipt.lines.length; lineI++){
      var palletLine = mraReceipt.lines[lineI];
      if (palletLine.pallets.some(pallet => pallet.glasschainId === sourcePallet)){
        return palletLine;
      }
    }
    return {};

  }

  handleInputChange = (inputValue) => {
    this.setState({ inputValue });
  };

  renderUntouchedState() {
    return (
      <div
        className="nonactivecard card-template shadow6"
        onClick={this.onCardClick}
      >
        {this.props.attribTitle}
      </div>
    );
  }

  renderActiveState() {

    const showPalletsBarString = ((this.state.cardValue) && (this.state.cardValue.palletIds) && (this.state.cardValue.palletIds.length>0)) ? 'visible': 'hidden';


    const bypassIcon = this.state.inBypass ? (
      <span>
      <FontAwesomeIcon icon={faSyncAlt} color="lightgreen" spin={true} />
      &nbsp;processing
    </span>   
    ) : (
      <span>
        <FontAwesomeIcon icon={faShareSquare} color="white" />
        &nbsp;&nbsp;Bypass
      </span>
    );

    const bypassButton = (this.props.bypassRules.allowBypass) ? (
      <Button
        id="bypassButton"
        onClick={(ev) => {
          this.onBypassClick(ev);
        }}
      >
      {bypassIcon}
    </Button>
    ) : (
      <span/>
    );




    const lookupIcon = this.state.inLookup ? (
      <span>
        <FontAwesomeIcon icon={faSyncAlt} color="lightgreen" spin={true} />
        &nbsp;searching
      </span>
    ) : (
      <span>
        <FontAwesomeIcon icon={faBinoculars} color="white" />
        &nbsp;&nbsp;Lookup
      </span>
    );

    const lookupError = this.state.lookupError ? (
      <div align="center" style={{ fontColor: "yellow" }}>
        {this.state.lookupErrMsg}
      </div>
    ) : (
      <span />
    );

    return (
      <div className="activecard shadow6 card-template textcard-input">
        <div onClick={this.onCardClick}>
          {this.props.attribTitle.toLowerCase()}
        </div>
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1">MRA Id</InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            id="mraId"
            placeholder="MRA ID"
            // value={this.state.mraId}
            onChange={(ev) => this.onMraIdChange(ev)}
            name="mraId"
          />
          &nbsp;&nbsp;
          <Button
            id="mraLookupButton"
            onClick={(ev) => {
              this.onMraLookupClick(ev);
            }}
          >
            {lookupIcon}
          </Button>
          &nbsp;&nbsp;
          {bypassButton}

            <div style={{visibility: showPalletsBarString, width: '100%'}}>
            <CreatableSelect
              components={components}
              inputValue={this.state.inputValue}
              isClearable
              isMulti
              menuIsOpen={false}
              onChange={this.handleChange}
              onInputChange={this.handleInputChange}
              onKeyDown={this.handleKeyDown}
              placeholder=""
              value={this.state.mraPalletPairs}
              id="palletSelectBar"
            />
            </div>

          {lookupError}
        </InputGroup>
      </div>
    );
  }

  renderTouchedState() {
    return (
      <div
        className="nonactivecard card-template touchedcard shadow7"
        onClick={this.onCardClick}
        style={{ backgroundColor: "lightgreen" }}
      >
        <div style={{ fontSize: "20px" }}>
          {this.props.attribTitle.toUpperCase()}
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "10px",
            fontColor: "purple",
          }}
        >
          {this.state.cardValue.palletIds.join(',')}
        </div>
      </div>
    );
  }

  renderState() {
    switch (this.state.cardState) {
      case "untouched":
        return this.renderUntouchedState();
      case "touched":
        return this.renderTouchedState();
      default:
        return this.renderActiveState();
    }
  }

  render() {
    return this.renderState();
  }
}
